import React, {useEffect, useState} from "react";
import {HttpClient} from "../../../service/httpClient/HttpClient";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import "./InternalAudioSelector.scss"
import AudioPlayer from "../../../component/players/audioPlayer/AudioPlayer";
import audioType from "../image/music-type.svg";
import {DialogSize, RaikoDefaultDialogPage, RaikoSectionContainer} from "@moeindal/base-raiko-panel-components";

export default function InternalAudioSelector(
    {
        value = -1,
        priority,
        editorValue,
        setEditorValue
    }
) {

    const [audioUrl, setAudioUrl] = useState("");

    useEffect(() => {
        if (typeof value !== "undefined" && value >= 0) {
            new HttpClient()
                .get(
                    `files/${value}/urls/public`
                ).then(response => {
                setAudioUrl(response.streamUrl.replaceAll("http:", "https:"))
            }).catch(reason => {
                console.log("image not loading by reason ", reason)
            })
        } else {
            setAudioUrl("")
        }
    }, [value])


    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function handleSelectAudio(id, url) {

        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(id, EditorItemType.INTERNAL_SOUND),
            priority)

    }

    return (
        <>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"صوت مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={FileManagerTypes.POST_AUDIOS.id}
                    setSelectedFileUrl={handleSelectAudio}
                />

            </RaikoDefaultDialogPage>
            <div className={"baseVideoSelectorContainer"}>
                <RaikoSectionContainer
                    title={"صوت"}
                    hasActionButton
                    actionButtonOnclick={handleOpenFileManager}
                    actionButtonTitle={value && value > -1 ? "تغییر صوت" : "انتخاب صوت"}
                >

                    {audioUrl && audioUrl.length > 0 ?
                        <AudioPlayer url={audioUrl}/>
                        :
                        <div
                            className={"videoNotSelectedContainer"}
                            onClick={handleOpenFileManager}
                        >
                            <img src={audioType} alt=""/>
                            <span>برای انتخاب صوت کلیک نمایید.</span>
                        </div>
                    }
                </RaikoSectionContainer>
            </div>
        </>

    )
}